





















import { computed, ref, defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useUserPublicData from "@/hooks/useUserPublicData";
import { livePreviewFragment } from "@/lib/fieldsHelper";
import { getLiveUrl } from "@/lib/urlHelpers";
import BasePage from "@/components/BasePage";
import BaseSpinner from "@/components/BaseSpinner";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import LivePreviewItem from "@/components/LivePreviewItem";
import PageTitle from "@/components/PageTitle/PageTitle";

export default defineComponent({
  name: "PageLives",
  components: { EmptyContent, BaseSpinner, LivePreviewItem, InfiniteScroll, PageTitle, BasePage },
  setup() {
    const loading = ref(false);
    const { enableScroll, users, getFirstPage, getNextPage } = useUserPublicData(
      computed(() => ({ role: "creator", isLive: true, discoveryOnly: true })),
      undefined,
      livePreviewFragment
    );

    const isCreatorInPrivate = (user: UserPublicData) =>
      !!user.publicLivechatUser && !user.publicLivechatUser.broadcasting;

    const getData = async () => {
      try {
        loading.value = true;
        await getFirstPage();
      } finally {
        loading.value = false;
      }
    };

    getData();

    return { loading, users, enableScroll, isCreatorInPrivate, getNextPage, getLiveUrl };
  },
});
